import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 物件検索条件 */
enum ArticleSearchCondition {
  allArticles = '1',
  articleExpireCurrentMonthNoRegReLease = '2',
  articleExpirationNotificationTarget = '3',
}

const nameConfig = {
  allArticles: new Map([
    [Locale.ja, '全ての物件'],
    [Locale.en, 'All Articles'],
  ]),
  articleExpireCurrentMonthNoRegReLease: new Map([
    [Locale.ja, '当月に満了する予定の物件のうち、再リース及び契約満了の登録がされていない物件'],
    [
      Locale.en,
      'Articles Due to Expire in the Current Month with No Registered Re-lease and Article Expiration',
    ],
  ]),
  articleExpirationNotificationTarget: new Map([
    [Locale.ja, '契約満了通知の対象と合致する契約に紐付く物件'],
    [Locale.en, 'Articles Related to Contracts Matching Contract Expiration Notification Target'],
  ]),
};

const toEnum = rawValueToEnum(ArticleSearchCondition, ArticleSearchCondition.allArticles);
const toDisplay = enumToName(ArticleSearchCondition, nameConfig);
const toDisplayWithPrefix = enumToName(ArticleSearchCondition, nameConfig, { prefix: true });

export const articleSearchCondition = {
  enum: ArticleSearchCondition,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { ArticleSearchCondition };
